import React, { useState, useEffect } from 'react';
import PhoneInput from 'react-phone-input-2';
import { useSelector, useDispatch } from 'react-redux';
import { setUser } from '../../../../redux/actions/user.actions';
import webServices from '../../../../services/webServices';
import { fetchData } from '../../../../services';

import zelleIcon from '../../../../assets/images/affiliate/zelle.png';
import VerifyZelleIdPopup from '../../../admin/modals/VerifyZelleIdPopup';


const PaymentSettings = () => {
  const dispatch = useDispatch();
  const { current } = useSelector((state) => state.user);
  const [amounts, setAmounts] = useState({});
  const [isModelVisible, setIsModelVisible] = useState(false);
  const [selectedRadioOption, setSelectedRadioOption] = useState('yes');
  const [mobileNoError, setMobileNoError] = useState('');

  useEffect(async () => {
    const resp = await fetchData('affiliate/amounts');
    if (resp && resp?.success) {
      setAmounts(resp?.data);
    }
  }, []);

  const handleModalCloseEvent = () => setIsModelVisible(false);

  const getZelleId = () => current.zelle_phone_no;
  const isZelleIdVerified = (zellePhoneNo = null) => {
    const tempZelleId = zellePhoneNo ?? getZelleId();

    return tempZelleId === current.phone ? 1 : current.is_zelle_phone_no_verified;
  };

  const [zelleIdData, setZelleIdData] = useState({
    zelle_phone_no: getZelleId(),
    is_zelle_phone_no_verified: isZelleIdVerified()
  });

  const handleRadioOptionChange = (evt) => {
    const radioSelectedOption = evt.target.value;
    setSelectedRadioOption(radioSelectedOption);

    setZelleIdData(prevData => ({
      ...prevData,
      zelle_phone_no: (radioSelectedOption === 'no' ? '' : getZelleId())
    }));
  };

  const validatePhoneNumber = () => {
    if (selectedRadioOption === 'yes') return true; // not required

    if (!zelleIdData.zelle_phone_no) return false; // required but empty

    return zelleIdData.zelle_phone_no.length >= 11;
  };

  const zelleIdChangeHandler = (phoneNo) => {
    setZelleIdData({
      zelle_phone_no: phoneNo,
      is_zelle_phone_no_verified: isZelleIdVerified(phoneNo)
    });
  };

  const saveBtnClickHandler = async () => {
    setMobileNoError('');
    if (!validatePhoneNumber()) {
      setMobileNoError('The mobile number field is required & must contain valid mobile number.');
    } else if (selectedRadioOption === 'no') {
      const prevZelleId = getZelleId();

      if (prevZelleId !== zelleIdData.zelle_phone_no) {
        const result = await webServices.sendOtp({ email: current.email, isResend: 0 });
        if (result && result.success) {
          setIsModelVisible(true);
        }
      }
    }
  };

  const emailVerifiedHandlerEvt = async () => {
    const resp = await webServices.updateUserDetails(current?.id, { zellePhoneNo: zelleIdData.zelle_phone_no });
    if (resp?.success === true) {
      dispatch(setUser(resp?.data));

      setSelectedRadioOption('yes');
    }
  }

  const makePrimaryBtnHandler = async (phoneNo) => {
    const resp = await webServices.updateUserDetails(current?.id, { zellePhoneNo: phoneNo });
    if (resp?.success === true) {
      setZelleIdData(prevData => ({ ...prevData, zelle_phone_no: resp?.data.zelle_phone_no }));
      dispatch(setUser(resp?.data));
    }
  }

  const deletePhoneNoBtnHandler = async (phoneNo) => {
    // eslint-disable-next-line
    if (confirm('Are you sure?')) {
      let phoneNoHistoryArr = [...(current?.zelle_phone_no_history ?? [])];
      phoneNoHistoryArr = phoneNoHistoryArr.filter(el => el !== phoneNo);

      const resp = await webServices.updateUserDetails(current?.id, { zellePhoneNoHistory: phoneNoHistoryArr });
      if (resp?.success === true) {
        dispatch(setUser(resp?.data));
      }
    }
  }

  return (
    <>
      <div className="aff_payment_setting">
        <div className="heading">Latest Payments</div>
        <div className="payment_box_wrapper ">
          <div className="box d-flex">
            <img src={zelleIcon} className="img-fluid " alt="zelle img" />
            <div className="count pl-2">${amounts?.lastPayout ?? '00.00'}</div>
          </div>
        </div>

        {/* Phone No's List */}
        {current.zelle_phone_no_history !== null && current.zelle_phone_no_history.length > 0 && (
          <div className='phone_wrapper'>
            {current.zelle_phone_no_history.map(phoneNo => (
              <div className='box'>
                <div className='left'>+{phoneNo}</div>
                {getZelleId() === phoneNo ? (
                  <div className='right'>
                    <div className='cursor-pointer'><i className="fa fa-check-circle" aria-hidden="true" /><span>Primary</span></div>
                  </div>
                ) : (
                  <div className='right'>
                    {/* eslint-disable-next-line */}
                    <div className='cursor-pointer' onClick={() => makePrimaryBtnHandler(phoneNo)}><i className="fa fa-circle-thin" aria-hidden="true" /><span>Make Primary</span></div>
                    {/* eslint-disable-next-line */}
                    <div className='cursor-pointer' onClick={() => deletePhoneNoBtnHandler(phoneNo)}><i className="fa fa-times" aria-hidden="true" /></div>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        <div className="pain_wrapper">
          <div className="affilate_custom_field_wrapper">
            <div className="row">
              <div className="col-12 border-custom">
                <div className="d-flex align-items-end">
                  <div className="field w-100 custome_select private_wrapper">
                    <div className="custom_input p-0">
                      <PhoneInput
                        containerClass="custom_flag"
                        placeholder="Phone Number"
                        className="number"
                        country="us"
                        value={zelleIdData.zelle_phone_no}
                        onChange={(phoneNo) => zelleIdChangeHandler(phoneNo)}
                        disabled={selectedRadioOption === 'yes'}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {(zelleIdData.zelle_phone_no === '' || zelleIdData.zelle_phone_no === null) && (
                <div className="input_alert">
                  <p className="mb-0">Enter your Zelle phone number here</p>
                </div>
              )}
              {mobileNoError && (<div className='srv-validation-message'>{mobileNoError}</div>)}
            </div>

            {/* Radio buttons */}
            <div className="row">
              <div className='col-md-12 col-lg-12 mb-4 mt-3 pl-0'>
                <div className='customeRadio_Inner'>
                  <input
                    type="radio"
                    value="yes"
                    id="radio-yes"
                    name='ph-no-radio-radio-group'
                    checked={selectedRadioOption === 'yes'}
                    onChange={handleRadioOptionChange}
                  />
                  <label htmlFor="radio-yes">YES, this is the phone number to my Zelle account</label>
                </div>

                <div className='customeRadio_Inner'>
                  <input
                    type="radio"
                    value="no"
                    id="radio-no"
                    name='ph-no-radio-radio-group'
                    checked={selectedRadioOption === 'no'}
                    onChange={handleRadioOptionChange}
                  />
                  <label htmlFor="radio-no">NO, this is NOT the phone number to my Zelle account</label>
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-12 mt-4 pl-0 pr-0">
                <button type="button" className="btn btn_aff_common saveBtn" onClick={saveBtnClickHandler} disabled={selectedRadioOption === 'yes'}>Save</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <VerifyZelleIdPopup isModalVisible={isModelVisible} handelClose={handleModalCloseEvent} emailVerifiedHandler={emailVerifiedHandlerEvt} user={current} />
    </>
  );
};

export default PaymentSettings;
